<form class="grow h-full" [waiting]="loadingService.isLoading(this)" [formGroup]="form">
  <icz-tabs class="grow tabs h-full" [tabs]="tabs" (tabClick)="tabChanged($event)">
    <ng-template [iczTab]="EntityClassResortingTab.DEFINITION">
      <div class="row mx-16">
        <div class="col grow">
          <icz-section label="Přetřídit do věcné skupiny">
            <icz-entity-class-selector [form]="form" controlName="targetEntityClassId" (valueChange)="onTargetEntityClassChange($event)" [usage]="usageBasedOnRole"></icz-entity-class-selector>
            <icz-date-picker label="Platnost věcné skupiny od" formControlName="targetEntityClassValidFrom"></icz-date-picker>
            <icz-form-autocomplete label="Skartační režim" formControlName="targetEntityClassDisposalScheduleId" [options]="disposalScheduleOptions"></icz-form-autocomplete>
            <icz-retention-trigger-type-widget [form]="form" [disposalScheduleId]="targetEntityClassDisposalScheduleIdControl.value"></icz-retention-trigger-type-widget>
          </icz-section>
        </div>
        <div class="col grow">
          <icz-section label="Věcná skupina, kterou chcete přetřídit">
            <icz-entity-class-selector [form]="form" controlName="sourceEntityClassId" (valueChange)="onSourceEntityClassChange($event)" [usage]="EntityClassSelectorUsage.ADMIN_HISTORIC_WITH_V"></icz-entity-class-selector>
            <icz-date-picker label="Platnost věcné skupiny do" formControlName="sourceEntityClassValidTo"></icz-date-picker>
            <icz-form-autocomplete label="Skartační režim" formControlName="sourceEntityClassDisposalScheduleId" [options]="disposalScheduleOptions"></icz-form-autocomplete>
            <icz-retention-trigger-type-widget [form]="form" [disposalScheduleId]="sourceEntityClassDisposalScheduleIdControl.value"></icz-retention-trigger-type-widget>
          </icz-section>
        </div>
      </div>
      <div class="mx-16">
        <icz-section label="Nastavení přetřídění">
          <icz-alert severity="info" class="mb-8" heading="fe.ui.textHelp.reclassification.crossReference"></icz-alert>
          @if (form.get('reclassifyObjectsInStoringUnits')!.value) {
            <icz-alert severity="warning" class="mb-8" heading="fe.ui.textHelp.reclassification.storingUnit"></icz-alert>
          }
          <icz-checkbox formControlName="reclassifyObjectsInStoringUnits" label="Přetřídit objekty v ukládacích jednotkách" class="mb-8"></icz-checkbox>
          <icz-checkbox formControlName="reclassifyObjectsInRegistryOffice" label="Přetřídit objekty předané do spisovny"></icz-checkbox>
        </icz-section>
      </div>
    </ng-template>
    <ng-template [iczTab]="EntityClassResortingTab.CONTENT">
      @if (dataSource) {
        <icz-documents-table
          class="grow"
          tableId="entity-class-resorting"
          tableTitle=""
          [allowOpenQuickPreview]="false"
          [hideTableToolbarButtons]="true"
          [viewType]="DocumentView.ENTITY_CLASS_RECLASSIFICATION"
          [dataSource]="dataSource"
          (selectAllChanged)="selectAllChanged($event)"
          (searchParamsSelected)="searchParamsSelected($event)"
          (selectedRowsChanged)="selectionChanged($event)">
          <icz-label noDataLabel label="Žádné entity k přetřídění"></icz-label>
        </icz-documents-table>
      }
    </ng-template>
  </icz-tabs>
</form>
<icz-form-buttons>
  <icz-button iczFormSubmit leftButtons primary (onAction)="submit()" label="Přetřídit" [disabled]="!enableReclassification"></icz-button>
  <icz-button rightButtons (onAction)="close()" label="Storno"></icz-button>
</icz-form-buttons>
